/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface ListProps {
    color?: string
    size?: string
    className?: string
}

const List = (props: ListProps) => {
    const { className = '', color = '#364152' } = props

    return (
        <span className={'flex items-center justify-center' + className}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.50002 18.3333H12.5C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V7.49999C18.3334 3.33332 16.6667 1.66666 12.5 1.66666H7.50002C3.33335 1.66666 1.66669 3.33332 1.66669 7.49999V12.5C1.66669 16.6667 3.33335 18.3333 7.50002 18.3333Z" stroke="#4B5565" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.125 7.5H6.875" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.125 12.5H6.875" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    )
}

export default List
